import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  page: null,
  simpleTaskStatus: null,
  isFetching: false,
  isProcessSimpleTaskStatus: false,
  isProcessComplete: false,
  isFetchingModule: false,
  isProcessUserState: false,
  isProcessJoinSimpleTask: false,
  isProcessSendSimpleTask: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchModuleLessonPage]: state => {
      return {
        ...state,
        page: initialState.page,
        isFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchModuleLessonPageSuccess]: (state, action) => {
      return {
        ...state,
        page: action.result,
        isFetching: false,
      }
    },
    [actions.fetchModuleLessonPageFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isFetching: false,
      }
    },
    [actions.fetchCourseUserState]: state => {
      return {
        ...state,
        isProcessUserState: true,
      }
    },
    [actions.fetchCourseUserStateSuccess]: (state, action) => {
      return {
        ...state,
        progress: action.result,
        isProcessUserState: false,
      }
    },
    [actions.fetchCourseUserStateFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessUserState: false,
      }
    },
    [actions.fetchSimpleTaskStatus]: state => {
      return {
        ...state,
        isProcessSimpleTaskStatus: true,
      }
    },
    [actions.fetchSimpleTaskStatusSuccess]: (state, action) => {
      return {
        ...state,
        simpleTaskStatus: action.result,
        isProcessSimpleTaskStatus: false,
      }
    },
    [actions.fetchSimpleTaskStatusFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessSimpleTaskStatus: false,
      }
    },
    [actions.joinSimpleTask]: state => {
      return {
        ...state,
        isProcessJoinSimpleTask: true,
      }
    },
    [actions.joinSimpleTaskSuccess]: state => {
      return {
        ...state,
        isProcessJoinSimpleTask: false,
      }
    },
    [actions.joinSimpleTaskFailure]: (state, action) => {
      return {
        ...state,
        isProcessJoinSimpleTask: false,
        error: action.error,
      }
    },
    [actions.sendSimpleTask]: state => {
      return {
        ...state,
        isProcessSendSimpleTask: true,
      }
    },
    [actions.sendSimpleTaskSuccess]: state => {
      return {
        ...state,
        isProcessSendSimpleTask: false,
      }
    },
    [actions.sendSimpleTaskFailure]: (state, action) => {
      return {
        ...state,
        isProcessSendSimpleTask: false,
        error: action.error,
      }
    },
    [actions.setLessonComplete]: state => {
      return {
        ...state,
        isProcessComplete: true,
      }
    },
    [actions.setLessonCompleteSuccess]: state => {
      return {
        ...state,
        isProcessComplete: false,
      }
    },
    [actions.setLessonCompleteFailure]: (state, action) => {
      return {
        ...state,
        isProcessComplete: false,
        error: action.error,
      }
    },
    [actions.fetchModule]: state => {
      return {
        ...state,
        isFetchingModule: true,
      }
    },
    [actions.fetchModuleSuccess]: (state, action) => {
      return {
        ...state,
        module: action.result,
        isFetchingModule: false,
      }
    },
    [actions.fetchModuleFailure]: (state, action) => {
      return {
        ...state,
        isFetchingModule: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
